import { createAsyncThunk } from '@reduxjs/toolkit';

// Slices
import { WidgetSettingsActions } from './widget-settings.slice';

// Services
import { WidgetSettingsService } from '../../services/widget-settings.service';

// Thunks
import { openNotification } from '../app-notifications/app-notifications.thunks';

// Models
import { IThemeSettings, IWidgetSettings } from '../../interfaces/widget-settings.interfaces';

export enum EWidgetSettingsActions {
  FetchWidgetSettings = 'WIDGET_SETTINGS/fetchWidgetSettings',
  UpdateWidgetTheme = 'WIDGET_SETTINGS/updateWidgetTheme',
  UpdateWidgetSettings = 'WIDGET_SETTINGS/updateWidgetSettings',
}

export const fetchWidgetSettings = createAsyncThunk(
  EWidgetSettingsActions.FetchWidgetSettings,
  async (_, { dispatch }: any) => {
    dispatch(WidgetSettingsActions.loadWidgetSettingsRequest());
    const { widget_settings, error } = await WidgetSettingsService.fetchWidgetSettings();
    if (!widget_settings) {
      dispatch(openNotification({
        type: 'error',
        description: error ?? 'Can`t load widget settings. Please reload page and try again'
      }));
      dispatch(WidgetSettingsActions.loadWidgetSettingsRequestError(error ?? 'Can`t load widget settings. Please reload page and try again'));
      return null;
    }
    dispatch(WidgetSettingsActions.loadWidgetSettingsRequestSuccess(widget_settings));
    return widget_settings;
  }
);

export const updateWidgetTheme = createAsyncThunk(
  EWidgetSettingsActions.UpdateWidgetTheme,
  async (theme_settings: IThemeSettings, { dispatch }: any) => {
    dispatch(WidgetSettingsActions.updateWidgetThemeRequest());
    const { widget_settings, error } = await WidgetSettingsService.updateWidgetTheme(theme_settings);
    if (!widget_settings) {
      dispatch(openNotification({
        type: 'error',
        description: error ?? 'Can`t update widget theme settings. Please reload page and try again'
      }));
      dispatch(WidgetSettingsActions.loadWidgetSettingsRequestError(error ?? 'Can`t update widget theme settings. Please reload page and try again'));
      return null;
    }
    dispatch(WidgetSettingsActions.loadWidgetSettingsRequestSuccess(widget_settings));
    return widget_settings;
  }
);

export const updateWidgetSettings = createAsyncThunk(
  EWidgetSettingsActions.UpdateWidgetSettings,
  async (settings: IWidgetSettings, { dispatch }: any) => {
    dispatch(WidgetSettingsActions.updateWidgetSettingsRequest());
    const { widget_settings, error } = await WidgetSettingsService.updateWidgetSettings(settings);
    if (!widget_settings) {
      dispatch(openNotification({
        type: 'error',
        description: error ?? 'Can`t update widget settings. Please reload page and try again'
      }));
      dispatch(WidgetSettingsActions.loadWidgetSettingsRequestError(error ?? 'Can`t update widget settings. Please reload page and try again'));
      return null;
    }
    dispatch(WidgetSettingsActions.loadWidgetSettingsRequestSuccess(widget_settings));
    return widget_settings;
  }
);
